<template>
    <div v-if="role.roleId" class="roleData">
        <div class="avatar">
            <img v-if="role.personAvatar == null " src="/src/assets/彼岸花.jpg" >
            <img v-if="role.personAvatar" :src="role.personAvatar" />
        </div>
        <div class="roleData">
            <div class="roleName">
                {{ role.roleName }}
            </div>
            <div class="roleInfo">
                {{ role.bodyName }}
                |
                {{ role.serverName }}
                |
                {{ role.forceName }}

            </div>
        </div>
        <!-- <div class="roleDataRow">
            <div class="roleDataItem1">
                <div class="roleDataLabel">
                    名称：
                </div>
                <div class="roleDataValue">
                    {{ role.roleName }}
                </div>
            </div>
            <div class="roleDataItem2">
                <div class="roleDataLabel">
                    体型：
                </div>
                <div class="roleDataValue">
                    {{ role.bodyName }}
                </div>
            </div>
        </div>

        <div class="roleDataRow">
            <div class="roleDataItem1">
                <div class="roleDataLabel">
                    区服：
                </div>
                <div class="roleDataValue">
                    {{ role.serverName }}
                </div>
            </div>
            <div class="roleDataItem2">
                <div class="roleDataLabel">
                    门派：
                </div>
                <div class="roleDataValue">
                    {{ role.forceName }}
                </div>
            </div>
        </div> -->
        <div class="button">
            <el-button type="primary" @click="gameImportData" style=" margin-left: auto;" data-v-step="5">确认导入</el-button>
        </div>
    </div>
</template>

<script>


export default {
    props: {
        role: {
            roleId: null,
            roleName: null,
            bodyName: null,
            serverName: null,
            zoneName: null,
            forceName: null,
            personAvatar: null
        }

    },
    methods: {
        async gameImportData() {
            const req = {
                roleId: this.role.roleId,
                zoneName: this.role.zoneName,
                serverName: this.role.serverName,
            }
            this.$emit("gameImportData", req);
        }
    }
}

</script>

<style lang="less">
.roleData {
    margin-left: auto;
    margin-right: auto;
    margin-top: 0px;
    margin-bottom: 0px;
    height: 100px;
    border-radius: 10px;
    padding: 10px;
    width: 500px;
    // border: 1px solid;
    background-color: rgb(243, 243, 243);
    display: flex;

    .avatar {
        width: 80px;
        img {
            height: 100%;
            border-radius: 30px;
        }
    }

    .roleData{
        display: block;
        text-align: left;
        width: 260px;
        .roleName{
            height: 50%;
            width: 100%;
            font-size: 20px;
            font-weight: bolder;
            color: crimson;
        }
        .roleInfo{
            height: 50%;
            width: 100%;
            font-size: 16px;
            font-family:"宋体";
            color: rgb(39, 29, 225);
        }
    }


    .button {
        width: 100px;
        display:flex;
        align-items:flex-end;
        .el-button{
            height: 40px;
        }
    }


    // .roleDataRow {
    //     display: flex;
    //     font-weight: bolder;

    //     .roleDataItem1 {
    //         display: flex;
    //         width: 60%;
    //     }

    //     .roleDataItem2 {
    //         display: flex;
    //         width: 40%;
    //     }
    // }
}
</style>
